import ReopenReviewButton from './ReopenReviewButton';
const meta = {
    title: 'Features/InspectionEdit/ReopenReviewButton',
    component: ReopenReviewButton,
    args: {
        inspectionId: 42,
        buttonText: 'Reopen Review',
        iimReviewStatus: 'iim_completed',
        isVisible: true
    }
};
export default meta;
// Admin-only recovery action shown on a completed IA review (IP-14971).
export const Completed = {};
// Renders nothing unless the review is completed.
export const NotCompleted = {
    args: { iimReviewStatus: 'iim_not_started' }
};
